import { executeTourAction } from "./UiActionBus";
import { pathMatches } from "./tourPaths";
import { queryTourTarget } from "./tourTarget";
import { stepWantsAdminSidebar } from "./stepWantsAdminSidebar";
import { exitLiveFullscreen } from "../hooks/useLiveFullscreen";

export { pathMatches, stepWantsAdminSidebar };

export function delay(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export function waitForPath(route, timeoutMs = 2000) {
  if (!route || pathMatches(route, window.location.pathname)) {
    return Promise.resolve(true);
  }
  const started = Date.now();
  return new Promise((resolve) => {
    const tick = () => {
      if (pathMatches(route, window.location.pathname)) {
        resolve(true);
        return;
      }
      if (Date.now() - started >= timeoutMs) {
        resolve(false);
        return;
      }
      window.setTimeout(tick, 40);
    };
    tick();
  });
}

export function waitForTourTarget(tourId, timeoutMs = 2800) {
  if (!tourId) return Promise.resolve(true);
  const started = Date.now();
  return new Promise((resolve) => {
    const tick = () => {
      const el = queryTourTarget(tourId);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.width > 0 || rect.height > 0) {
          resolve(true);
          return;
        }
      }
      if (Date.now() - started >= timeoutMs) {
        resolve(false);
        return;
      }
      window.setTimeout(tick, 80);
    };
    tick();
  });
}

/** Navigate to the step's page, run its arrive action, then wait for the highlight target. */
export async function arriveOnTourStep(step, { navigate } = {}) {
  if (!step) return false;
  if (step.homeRole) {
    executeTourAction({ type: "setHomeRole", role: step.homeRole }, { navigate });
  }
  // Leave live-training fullscreen before home FAB steps — the global Pingflo
  // FAB is not mounted on /live-training.
  if (step.route && step.route !== "/live-training") {
    try {
      await exitLiveFullscreen();
    } catch {
      /* ignore */
    }
  }
  if (step.route && !pathMatches(step.route, window.location.pathname)) {
    if (typeof navigate === "function") navigate(step.route);
  }
  if (step.route) await waitForPath(step.route);
  if (step.route === "/live-training") await delay(180);
  if (step.closeSidebar) {
    executeTourAction({ type: "openPanel", panel: "adminSidebar", open: false }, { navigate });
    await delay(220);
  } else if (stepWantsAdminSidebar(step)) {
    executeTourAction({ type: "openPanel", panel: "adminSidebar" }, { navigate });
    await delay(320);
  }
  if (step.arrive) {
    const readyId = step.readyTourId || step.fallbackTourId;
    if (readyId) {
      await waitForTourTarget(readyId, 2000);
    } else {
      await delay(120);
    }
    executeTourAction(step.arrive, { navigate });
    if (step.arrive.panel === "profileSmart") await delay(160);
  } else {
    await delay(60);
  }
  if (step.tourId) {
    const found = await waitForTourTarget(step.tourId);
    if (found) return true;
    if (step.navTourId) {
      const navFound = await waitForTourTarget(step.navTourId, 1200);
      if (navFound) return true;
    }
    if (step.fallbackTourId) return waitForTourTarget(step.fallbackTourId, 1200);
    return false;
  }
  if (step.navTourId) return waitForTourTarget(step.navTourId);
  return true;
}
